import React from 'react'
import { ForceGraph3D } from 'react-force-graph'
import { connect } from 'react-redux'
import { createUserInput } from '../store/actions/userInputActions'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import * as d3 from 'd3'
import * as THREE from 'three'
import logo from './01b.png';
import $ from "jquery";

class DataSky extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            theme: "",
            viewPort: "NO_CONTROLS",
            escUpdate: false,
            font: ""
        }

        this.themeSelector = React.createRef();

		this.orbit = true;
        this.orbitInterval = ""
        this.zoomOutTimeout = ""
        this.orbitTimeout = ""
        this.orbitSpeed = 300;
        this.distance = 3500;
        this.originalCameraPosition = [{x:0, z: this.distance }, { x: 0, y: 0, z: 0 }, 3000];
		this.zoomOutTimeout = ""
		this.backToOrbitTimeout = ""
        this.font = {}

    }

    componentDidMount() {
        let that = this;
        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
        let showMenu = urlSearch.get("showMenu") === "1" ? "W_CONTROLS" : "NO_CONTROLS"
        this.setState({ viewPort: showMenu })
    }

    // componentWillMount() {
    //     window.addEventListener("keydown", (e) => this._handleEscKey(e), false);
    // }


    // componentWillUnmount() {
    //     window.removeEventListener("keydown", (e) => this._handleEscKey(e), false);
    // }

    componentDidUpdate() {
        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
			
		//if(urlSearch.get("orbit") == "0") {orbit = false}
		if(urlSearch.get("showMenu") == "1") {this.orbit = false}

        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            // x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        if (this.fg) {
            this.fg.cameraPosition(...this.originalCameraPosition);
            this.fg.d3Force("charge").strength(-700)
            this.fg.d3Force("link").distance(y / 2)
        }

        if (this.orbit && this.state.viewPort === "NO_CONTROLS" && this.fg) {
            setTimeout(() => {
				this.enableOrbit(true)
            }, 3000);
        }


    }

    shouldComponentUpdate(nextProps, nextState) {

        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;

        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
        let session = urlSearch.get("session")
        if (nextState.escUpdate === true) {
            return true
        }

        if (this.state.viewPort === "W_CONTROLS" && this.fg) {
            // if (nextProps.interactions !== this.props.interactions) {
            // return false
            // }
            let theme = nextState.theme
            if (session) {
                theme = nextProps.interactions && nextProps.interactions.length > 0 ? nextProps.interactions[0].theme : null
            }
            this.fg.props.graphData.nodes.forEach(node => {
                if (node.name === theme) {
						$(".datasky-tooltip").html(node.texto)
						$(".datasky-tooltip").css({ top: `${y / 2}px`, left: `${x / 2}px`, opacity: "1" })
                        this.zoomToNode(node);
                    }
            });
            return false
        } else if (this.state.viewPort === "NO_CONTROLS" && this.fg) {
            let theme = nextProps.interactions && nextProps.interactions.length > 0 ? nextProps.interactions[0].theme : null
            if (session !== nextProps.interactions[0].session) {
                return false;
            }
            if (theme) {
                this.fg.props.graphData.nodes.forEach(node => {
                    if (node.name === theme) {
						$(".datasky-tooltip").html(node.texto)
						$(".datasky-tooltip").css({ top: `${y / 2}px`, left: `${x / 2}px`, opacity: "1" })
                        this.zoomToNode(node);
                    }
                });
                return false
            }
        }
        return true
    }

    focusTheme(theme) {

        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
        let session = urlSearch.get("session")

        if (session) {
            this.props.createUserInput({
                createdAt: new Date(),
                theme: theme,
                session: session
            })
        } else {
            this.setState({
                theme,
                escUpdate: false
            })
        }

    }

    _handleEscKey(event) {
        let noControls = "NO_CONTROLS"
        let wControls = "W_CONTROLS"

        // toggle viewport type
        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
        let showMenu = urlSearch.get("showMenu")
        if (showMenu !== "0") {
            if (event.keyCode === 27) {
                let viewPort = this.state.viewPort === noControls ? wControls : noControls
                this.setState({
                    viewPort: viewPort,
                    escUpdate: true
                })
            }
        }
    }

    showMenu(event) {
        this.themeSelector.current.style.display = this.themeSelector.current.style.display === "flex" ? "none" : "flex"
    }

    render() {
        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;

        let data = this.getData()
        let max = d3.max(data.nodes, d => d.conexoes)
        let min = d3.min(data.nodes, d => d.conexoes)

        let nodeRadius = d3.scaleLinear()
            .domain([min, max])
            .range([5, 50])

        if (data && this.props.interactions && this.props.interactions.length > 0) {
            return (
                <div>
                    <ForceGraph3D
                        className={"graph-d3"}
                        ref={el => { this.fg = el; }}
                        graphData={data}
                        width={x}
                        height={y}
                        nodeId={'name'}
                        nodeLabel={node => `<p class="datasky-label">${node.texto}</p>`}
                        nodeColor={d => d.cor === "#ffffff" ? "#3e3e3f" : d.cor}
                        nodeVal={d => nodeRadius(d.conexoes)}
                        onNodeClick={this._handleClick}
                        nodeThreeObject={({ cor, tipo, conexoes, texto }) => {
                            return new THREE.Mesh(
                                new THREE.SphereGeometry(nodeRadius(conexoes)),
                                new THREE.MeshLambertMaterial({
                                    color: cor,
                                    transparent: true,
                                    opacity: 0.75
                                })
                            )
                        }}
                        linkOpacity={0.10}
                        numDimensions={3}
                        linkColor={d => d.cor}
                        forceEngine={'d3'}
                        enableNavigationControls={this.state.viewPort === "W_CONTROLS" ? true : false}
                        enableNodeDrag={false}
                        showNavInfo={false}
                        backgroundColor={"#000"}
                    />
                    {this.renderThemeSelector()}
                    <div className="datasky-tooltip"></div>
                    <i className="icon icon--plus" onClick={(e) => this.showMenu(e)} style={{ display: this.state.viewPort === "W_CONTROLS" ? "inline-block" : "none" }}></i>
                    <div className={"logo-holder"}>
                        <img src={logo} alt={"logo"} />
                        <div className={"site"}>DATASKY.ORG</div>
                    </div>
                </div>
            );
        }
        return <div></div>
    }

    renderThemeSelector() {
        let url = window.location.search.substring(1)
        let urlSearch = new URLSearchParams(url)
        let showMenu = urlSearch.get("showMenu")
        if (showMenu !== "0" && this.state.viewPort === "W_CONTROLS") {
            return (
                <div className="themeSelector" ref={this.themeSelector} id="theme-selector" style={{ display: "flex" }}>
                    <div style={{ "backgroundColor": "#5cbce0", "color": "#000" }} onClick={() => this.focusTheme("Educacao")} className="theme">
                        <p className="theme-title">EDUCAÇÃO</p>
                    </div>
                    <div style={{ "backgroundColor": "#3066a3", "color": "#000" }} onClick={() => this.focusTheme("Saude")} className="theme">
                        <p className="theme-title">SAÚDE</p>
                    </div>
                    <div style={{ "backgroundColor": "#cdcdcd", "color": "#000" }} onClick={() => this.focusTheme("Seguranca")} className="theme">
                        <p className="theme-title">SEGURANÇA PÚBLICA</p>
                    </div>
                    <div style={{ "backgroundColor": "#d74d80", "color": "#000" }} onClick={() => this.focusTheme("Infraestrutura")} className="theme">
                        <p className="theme-title">INFRAESTRUTURA</p>
                    </div>
                    <div style={{ "backgroundColor": "#de6635", "color": "#000" }} onClick={() => this.focusTheme("Alimentos")} className="theme">
                        <p className="theme-title">ALIMENTOS</p>
                    </div>
                    <div style={{ "backgroundColor": "#ecea50", "color": "#000" }} onClick={() => this.focusTheme("Energia")} className="theme">
                        <p className="theme-title">ENERGIA</p>
                    </div>
                    <div style={{ "backgroundColor": "#66d754", "color": "#000" }} onClick={() => this.focusTheme("Meio Ambiente")} className="theme">
                        <p className="theme-title">MEIO AMBIENTE</p>
                    </div>
                    <div style={{ "backgroundColor": "#9b9d9f", "color": "#000" }} onClick={() => this.focusTheme("Financeiro")} className="theme">
                        <p className="theme-title">FINANCEIRO</p>
                    </div>
                </div>
            )

        }

    }

    getData() {
        const nodes = Object.values(require('./data/nodes2k5.json'));
        const links = Object.values(require('./data/links2k5.json'));
        let data = {
            nodes,
            links
        }

        return data;
    }

	enableOrbit(enable = true, interval = 16, transition = 0) {
		clearInterval(this.orbitInterval);
		let angle = 0;
		if(this.orbit && enable) {
			this.orbitInterval = setInterval(() => {
				this.fg.cameraPosition({
						x: this.distance * Math.sin(angle),
						z: this.distance * Math.cos(angle)
				}, { x: 0, y: 0, z: 0 }, transition);
				angle += Math.PI / this.orbitSpeed;
			}, interval);
		}
	}

	zoomToNode(node) {
		this.enableOrbit(false);
		const zoomDistance = 900;
		const zoomDistRatio = 1 + zoomDistance / Math.hypot(node.x, node.y, node.z);
	
		// center camera on node
		this.fg.cameraPosition(
			{ x: node.x * zoomDistRatio, y: node.y * zoomDistRatio, z: node.z * zoomDistRatio }, // new position
			node, // lookAt ({ x, y, z })
			3000  // ms transition duration
		);
		// zoom out
		clearTimeout(this.zoomOutTimeout);
		clearTimeout(this.backToOrbitTimeout);
		this.zoomOutTimeout = setTimeout(() => {
			this.fg.cameraPosition(...this.originalCameraPosition);
			$(".datasky-tooltip").css({ top: `0`, left: `0`, opacity: "0" })
			clearTimeout(this.backToOrbitTimeout);
			this.backToOrbitTimeout = setTimeout(() => {
				this.enableOrbit(true);
			}, 3000);
		}, 5000);

	}
		

}

const mapStateToProps = (state) => {
    return {
        interactions: state.firestore.ordered.interactions
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createUserInput: (userInput) => dispatch(createUserInput(userInput))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect([
        { collection: 'interactions', orderBy: ['createdAt', 'desc'] }
    ])
)(DataSky);
